import { render } from "./MainTheme.vue?vue&type=template&id=3b3e0f88&scoped=true"
import script from "./MainTheme.vue?vue&type=script&lang=js"
export * from "./MainTheme.vue?vue&type=script&lang=js"

import "./MainTheme.vue?vue&type=style&index=0&id=3b3e0f88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3e0f88"]])

export default __exports__